<div class="flex flex-col gap-2">
  @if (props.label) {
    <label [for]="id" class="font-semibold">
      {{ props.label }}
      @if (props.required) {
        <span class="text-red-500">*</span>
      }
    </label>
  }

  <!-- Regular text input -->
  <input
    [id]="id"
    [formControl]="inputFormControl"
    type="text"
    [placeholder]="props.placeholder || ''"
    [attr.maxlength]="props.maxLength ?? null"
    (blur)="onBlur()"
    [class]="
      'w-full p-3 border rounded outline-none ' +
      (isFieldInvalid() ? 'border-red-500' : 'border-surface-200 dark:border-surface-700')
    "
    [ngClass]="{ 'p-disabled': formControl.disabled }"
  />

  @if (props.description) {
    <div class="text-sm text-surface-600 dark:text-surface-400">
      {{ props.description }}
    </div>
  }

  @if (isFieldInvalid()) {
    <small class="text-red-500">{{ getErrorMessage() }}</small>
  }
</div>
